export default __webpack_public_path__ + "static/media/placeholder.f05e0d95.png";